import { Area, CellPosition } from '../../types';
import { AddressType } from '../../types/sheet/address';
import {
  indexToColumnLetter,
  isSingleCell,
  isSingleColumn,
} from '../area/area';
import {
  IsCellPosition,
  IsCellRange,
  IsRangeAddress,
  isCellPosition,
  isCellRange,
  isColumnRange,
  isRowRange,
} from './parsingAddress';

// #region single address

export type ParseSingleAddress =
  | (IsRangeAddress & { type: AddressType.Column | AddressType.Row })
  | (IsCellPosition & { type: AddressType.Position })
  | (IsCellRange & { type: AddressType.Range });

export const parseSingleAddress = (address: string): ParseSingleAddress => {
  const cellPos = isCellPosition(address);
  if (cellPos) {
    return {
      type: AddressType.Position,
      ...cellPos,
    };
  }

  const cellRange = isCellRange(address);
  if (cellRange) {
    return {
      type: AddressType.Range,
      ...cellRange,
    };
  }

  const colRange = isColumnRange(address);
  if (colRange) {
    return {
      type: AddressType.Column,
      ...colRange,
    };
  }

  const rowRange = isRowRange(address);
  if (rowRange) {
    return {
      type: AddressType.Row,
      ...rowRange,
    };
  }

  throw new Error('Invalid Address');

  // if (address.match(singleCellRegex)) {
  //   // Address like A1 (single cell)
  //   const colIndex = address.charCodeAt(0) - 'A'.charCodeAt(0);
  //   const rowIndex = parseInt(address.slice(1)) - 1;
  //   return {
  //     type: AddressType.Position,
  //     position: {
  //       ci: colIndex,
  //       ri: rowIndex,
  //     },
  //   };
  // }

  // if (address.match(rowAddressRegex)) {
  //   // Address like 17:17 (only row)
  //   const start = parseInt(address.split(':')[0]) - 1;
  //   const end = parseInt(address.split(':')[1]) - 1;
  //   return {
  //     type: AddressType.Row,
  //     range: {
  //       start,
  //       end,
  //     },
  //   };
  // }

  // if (address.match(columnAddressRegex)) {
  //   // Address like A:A (only column)
  //   const start = address.charCodeAt(0) - 'A'.charCodeAt(0);
  //   const end = address.charCodeAt(2) - 'A'.charCodeAt(0);

  //   return { type: AddressType.Column, range: { start: start, end: end } };
  // }

  // if (address.match(cellRangeRegex)) {
  //   // Address like A1:A5 or B1:C6 (specific range)
  //   const [start, end] = address.split(':');
  //   const startColIndex = start.charCodeAt(0) - 'A'.charCodeAt(0);
  //   const startRowIndex = parseInt(start.slice(1)) - 1;
  //   const endColIndex = end.charCodeAt(0) - 'A'.charCodeAt(0);
  //   const endRowIndex = parseInt(end.slice(1)) - 1;

  //   return {
  //     type: AddressType.Range,
  //     area: {
  //       start: { ri: startRowIndex, ci: startColIndex },
  //       end: { ri: endRowIndex, ci: endColIndex },
  //     },
  //   };
  // }

  // throw new Error('Invalid address');
};
// #endregion

// #region createAddressFromFormula
// export const createAddressFromFormula = (formula: string) => {
//   const addresses = formula.match(formulaAddressParseRegex);

//   if (addresses) {
//     for (const address of addresses) {
//       // let adrCheck = address.toUpperCase()
//       // if (formulasList.includes(adrCheck)) continue;
//       // if (adrCheck === "FALSE" || adrCheck === "TRUE") continue
//       // if (address.length === 1) continue
//     }
//   }
// };
// #endregion

export const convertPositionToAddress = ({ ci, ri }: CellPosition) => {
  const letter = indexToColumnLetter(ci);
  return `${letter}${ri + 1}`;
};

export const convertAreaToAddressString = (
  area: Area,
  maxColIndex: number,
  maxRowIndex: number,
  sheetName?: string
) => {
  let address = '';
  if (isSingleCell(area)) {
    address = `${convertPositionToAddress(area.start)}`;
  }

  // const isCellRange =
  //   area.start.ri !== 0 ||
  //   area.start.ci !== 0 ||
  //   area.end.ri !== maxRowIndex ||
  //   area.end.ci !== maxColIndex;

  // console.log('area', area, isCellRange);

  // if (isCellRange) {
  //   const start = convertPositionToAddress(area.start);
  //   const end = convertPositionToAddress(area.end);
  //   return `${start}:${end}`;
  // }

  if (area.start.ri === 0 && area.end.ri === maxRowIndex) {
    const startColumn = indexToColumnLetter(area.start.ci);
    const endColumn = indexToColumnLetter(area.end.ci);

    address = `${startColumn}:${endColumn}`;
  }

  if (area.start.ci === 0 && area.end.ci === maxColIndex) {
    address = `${area.start.ri + 1}:${area.end.ri + 1}`;
  }

  if (!address.length) {
    const start = convertPositionToAddress(area.start);
    const end = convertPositionToAddress(area.end);

    address = `${start}:${end}`;
  }

  if (sheetName) {
    if (sheetName.includes(' ')) {
      return `'${sheetName}'!${address}`;
    } else {
      return `${sheetName}!${address}`;
    }
  }

  return address;
};
